/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGetByKeyQueryResponse, ContentGetByKeyPathParams } from "../models/ContentGetByKey";

export function getContentGetByKeyUrl(key: ContentGetByKeyPathParams["key"]) {
  const res = { method: 'GET', url: `/contents/key/${key}` as const }  
  return res
}

/**
 * @description Keys are used to identify fragments based on an external ID (e.g.: `FRAGMENT:123456`)
 * @summary Get content by key
 * {@link /contents/key/:key}
 */
export async function contentGetByKey(key: ContentGetByKeyPathParams["key"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ContentGetByKeyQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getContentGetByKeyUrl(key).url.toString(), ... requestConfig })  
  return res.data
}